<template>
  <li class="row-content" :class="containerClass">
    <i class="fa fa-users row-content--side"></i>
    <span v-line-clamp="lineClamp" @click.stop  class="row-content--main">
      <span v-if="isText" class="t-500">{{ 'Research Group' | pluralize(researchGroups.length) }}:</span>
      <span v-if="renderWithLinkTo">
        <span v-for="(researchGroup, index) in researchGroups" :key="index" :class="{ 'pr-1' : researchGroups.length -1 !== index }">
          <router-link
            v-if="researchGroup.slug_values && researchGroup.slug_values.length > 0"
            :to="{ name: 'research_group.show', params: {id: researchGroup.slug_values[0]} }"
            class="d-inline-block"
            v-html="getResearchGroupName(researchGroup)">
          </router-link><span v-else>{{ getResearchGroupName(researchGroup) }}</span><span v-if="index + 1 < researchGroups.length">, </span>
        </span>
      </span>
      <span v-else v-html="getResearchGroupsAsString()"></span>
    </span>
  </li>
</template>

<script>

export default {
  name: 'searchResearchGroups',
  props: {
    researchGroups: {
      type: Array,
      required: true
    },
    highlights: {
      type: Object,
      required: true
    },
    highlightKey: {
      type: String,
      required: false,
      default: 'research_groups.name'
    },
    containerClass: {
      type: String,
      default: ''
    },
    lineClamp: {
      type: Number,
      default: -1
    },
    renderWithLinkTo: {
      type: Boolean,
      default: true
    },
    truncate: {
      type: Number,
      default: 50
    },
    isText: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getResearchGroupsAsString () {
      let researchGroupStr = ''
      for (const [key, value] of this.researchGroups.entries()) {
        researchGroupStr += this.getResearchGroupName(value)
        if (key < this.researchGroups.length - 1) researchGroupStr += ', '
      }

      return researchGroupStr
    },
    getResearchGroupName (researchGroup) {
      if (this.highlights && this.highlights[this.highlightKey]) {
        let org = researchGroup.name
        for (let o of this.highlights[this.highlightKey]) if (researchGroup.name === this.stripTags(o)) org = o
        return this.$options.filters.truncate(org, this.truncate)
      } else if (researchGroup.name) {
        return this.$options.filters.truncate(researchGroup.name, this.truncate)
      }

      return this.$options.filters.truncate(researchGroup.name, this.truncate)
    }
  }
}
</script>
